import React, { useState, useEffect, useRef } from "react";
import client from "../contentfulClient";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const Prizes = _ref => {
  var _posts$fields, _posts$fields2, _posts$fields3, _posts$fields4;
  let {
    navigate
  } = _ref;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  let memberId = localStorage.getItem("memberId");
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        const entry = await client.getEntry("4T9XV3OTiDjCxJEhrs1sJe");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        console.log({
          ...entry,
          fields: resolvedFields
        });
        setSkeletonLoading(false);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  const tabRefs = useRef([]);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "<p>$1</p>&nbsp;");
      return pageTitleVar;
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "all-prizes-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "all-prizes-container-1",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.headerImage) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.file) === null || _posts$fields === void 0 ? void 0 : _posts$fields.url, ")"),
      backgroundSize: "34%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "linear-gradient(274.19deg, #ebbd67 15.62%, #ffeac3 79.63%, #e1b667 87.79%)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      backgroundClip: "text",
      fontWeight: "800",
      fontSize: "36px",
      lineHeight: "42px",
      paddingBottom: "25px"
    }
  }, posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.weeklyHeader), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "10px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 165,
    width: 342,
    borderRadius: 10,
    count: 5,
    style: {
      opacity: "0.2",
      marginBottom: "10px"
    }
  })) : posts === null || posts === void 0 || (_posts$fields3 = posts.fields) === null || _posts$fields3 === void 0 ? void 0 : _posts$fields3.weeklyContainer.map((item, index) => {
    var _item$fields, _item$fields2, _item$fields3;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "heading",
      dangerouslySetInnerHTML: {
        __html: pageTitleFunc(item === null || item === void 0 || (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.headerText)
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "draw-date",
      dangerouslySetInnerHTML: {
        __html: pageTitleFunc(item === null || item === void 0 || (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.prizeDate)
      }
    }), item === null || item === void 0 || (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.prizeImages.map((item1, index1) => /*#__PURE__*/React.createElement("div", {
      style: {
        paddingBottom: "20px"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item1.fields.file.url,
      style: {
        width: "100%"
      }
    }))));
  }), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "300",
      paddingBottom: "50px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, posts === null || posts === void 0 || (_posts$fields4 = posts.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.weeklyFooter) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.content) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4[0]) === null || _posts$fields4 === void 0 ? void 0 : _posts$fields4.content.map((node, index) => {
    if (node.nodeType === "text") {
      return /*#__PURE__*/React.createElement("span", {
        key: index
      }, node.value);
    }
    if (node.nodeType === "hyperlink") {
      return /*#__PURE__*/React.createElement("a", {
        key: index,
        href: node.data.uri,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          color: "#F1CB83",
          textDecoration: "none"
        }
      }, node.content[0].value);
    }
    return null;
  })))));
};
export { Prizes };